module.exports = __webpack_public_path__ + "img/seven2Orange.8da882c2.jpg";